export default __webpack_public_path__ + "static/media/scroll_down_logo.8c0c54fe.webp";